import { DOMAIN_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const AdminDomainServices = {
  fetchDomains: async (params: any) => {
    const response = await axiosClient.get(`${DOMAIN_API_URL}/master-domain`, {
      params
    });
    return response.data;
  },
  deleteDomain: async (domainId: string) => {
    try {
      const response = await axiosClient.delete(`${DOMAIN_API_URL}`, {
        params: {
          domainId
        }
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  updateDomain: async (body: any, domainId: any) => {
    try {
      const response = await axiosClient.put(`${DOMAIN_API_URL}/${domainId}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  downloadDomain: async () => {
    try {
      const response = await axiosClient.get(`${DOMAIN_API_URL}/download`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  }
};

export default AdminDomainServices;
